import Row from './row';
import Col from './col';
export { Row, Col };


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/grid/index.js
// module id = 331
// module chunks = 0